import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";

import AppTheme from "../../../AppTheme";

export default function ChangeTimeIcon(props) {
  const color = AppTheme.DEFAULT_COLOR;

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={props.style} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M7.70711 8.29289C7.07714 8.92286 7.52331 10 8.41421 10H15.5858C16.4767 10 16.9229 8.92286 16.2929 8.29289L12.7071 4.70711C12.3166 4.31658 11.6834 4.31658 11.2929 4.70711L7.70711 8.29289Z"
          fill={color}
        />
        <Path
          d="M11.2929 19.2929C11.6834 19.6834 12.3166 19.6834 12.7071 19.2929L16.2929 15.7071C16.9229 15.0771 16.4767 14 15.5858 14H8.41421C7.52331 14 7.07714 15.0771 7.70711 15.7071L11.2929 19.2929Z"
          fill={color}
        />
      </Svg>
    </TAG>
  );
}
